<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="isPartner ? ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.materieleVasteActiva?.at(1)?.waardeSlot ?? null) === null : ((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.materieleVasteActiva?.at(1)?.waardeSlot ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg"
                                title="Specificatie machines en installaties">
  <snelstart-ui-dialog-header-content>
    Vul onderstaand de waardes is voor de balanspost(en) per einde van het boekjaar.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
    <form [formGroup]="formGroup" (change)="saveForm()">
      <div>
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="aanschafWaarde"
                                          label="Aanschafwaarde"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div>
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="restWaarde"
                                          label="Restwaarde"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </form>
  </snelstart-ui-dialog-body>

  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button icon="check" id="save" type="primary" [disabled]="formGroup.invalid">Opslaan</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
